import React, { useContext } from 'react';

import styled from '@emotion/styled';

import TranslatingContainer from '../../../TranslatingContainer/TranslatingContainer';
import TranslatingContainerProvider from '../../../TranslatingContainer/TranslatingContainerProvider';
import WhatIsNewButtonControl from './WhatIsNewButtonControl';
import WhatIsNewContent from './WhatIsNewContent';
import { whatIsNewContentData } from './WhatIsNewContentData';
import WhatIsNewModalContainer from './WhatIsNewModalContainer';
import WhatIsNewModalProvider, { WhatIsNewModalContext } from './WhatIsNewModalProvider';

export const STORAGE_KEY = 'hasSeenWhatsNewModal';

const WhatsNewModalInner = () => {
  const { activeSlideHeight } = useContext(WhatIsNewModalContext);

  return (
    <WhatIsNewModalContainer>
      <Badge>New Update</Badge>
      <Container height={activeSlideHeight}>
        <TranslatingContainer width={794}>
          <WhatIsNewContent data={whatIsNewContentData} />
        </TranslatingContainer>
      </Container>
      {/* Button area */}
      <WhatIsNewButtonControl />
    </WhatIsNewModalContainer>
  );
};

const WhatsNewModal = () => {
  return (
    <TranslatingContainerProvider>
      <WhatIsNewModalProvider data={whatIsNewContentData}>
        <WhatsNewModalInner />
      </WhatIsNewModalProvider>
    </TranslatingContainerProvider>
  );
};

export default WhatsNewModal;

const Container = styled.div<{ height: number }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  overflow: hidden;
  transition: height 0.3s ease-in-out;
`;

const Badge = styled.div`
  background-color: ${({ theme }) => theme.palette.blueColor};
  width: fit-content;
  color: white;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;

  border-radius: 6px;
  padding: 8px;
`;
